import {
  UNDOREDO_ADD,
  EDITOR_DELETE,
  UNDOREDO_ADD_COVER,
} from "../Constants/EditorConstants";
export const undoRedo = (data) => async (dispatch) => {
  try {
    dispatch({
      type: UNDOREDO_ADD,
      payload: { ...data },
    });
  } catch (error) {
    dispatch({
      type: EDITOR_DELETE,
      payload:
        error.response && error.response.data
          ? error.response.data.error
          : error.message,
    });
  }
};

export const undoRedoCover = (data) => async (dispatch) => {
  try {
    dispatch({
      type: UNDOREDO_ADD_COVER,
      payload: { ...data },
    });
  } catch (error) {
    dispatch({
      type: EDITOR_DELETE,
      payload:
        error.response && error.response.data
          ? error.response.data.error
          : error.message,
    });
  }
};
